import { baseApi } from "./baseApi";

const marketTrendApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMarketTrends: builder.query({
      query: ({ loanCloseDays = 30, loanType = "Conventional", riskTolerance = "moderate" } = {}) => ({
        url: "/market-data/trends",
        method: "GET",
        params: { loanCloseDays, loanType, riskTolerance },
      }),
      providesTags: ["MarketTrends"],
    }),
  }),
});

export default marketTrendApi;
